import { useLocation, useNavigate } from "react-router-dom";
import type { Locale } from "../content/types";
import { getLocalizedPath } from "../lib/locale";

type LanguageSwitchProps = {
  locale: Locale;
  labels: Record<Locale, string>;
  ariaLabel: string;
};

// 胶囊里铺一个透明的原生 select:外观自己画,展开列表、键盘操作与移动端
// 系统选择器都交给浏览器。并排渲染其余语言的老做法在三语下会占两个位置,
// 而且当前语言反倒看不见,再加一门语言还会继续变宽
// 选项直接从 labels 的键来:labels 是 Record<Locale, string>,加一门语言时
// 内容那边不补就编译不过,这里不必再维护一份语言清单
export function LanguageSwitch({ locale, labels, ariaLabel }: LanguageSwitchProps) {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <span className="language-switch">
      <span className="language-switch-current" aria-hidden="true">
        {labels[locale]}
      </span>
      <select
        className="language-switch-select"
        aria-label={ariaLabel}
        value={locale}
        onChange={(event) => {
          navigate(getLocalizedPath(location.pathname, event.target.value as Locale));
        }}
      >
        {(Object.keys(labels) as Locale[]).map((target) => (
          <option key={target} value={target}>
            {labels[target]}
          </option>
        ))}
      </select>
    </span>
  );
}
